import { User } from "@models/User";

export const checkIsBusinessUser = (user?: User | null) =>
    user?.userType === "business_admin" || user?.userType === "business_user" || user?.userType === "demo";
